import { CHANGE_BIKE_MODEL_VARIANTS_REQUEST, CHANGE_BIKE_MODEL_VARIANTS_REQUEST_SUCCESS, CHANGE_BIKE_MODEL_VARIANTS_REQUEST_FAILURE } from '../constants/bike_model_variants.constants';

const prefix = 'CHANGE';
export const changeBikeModelVariantRequest = (variant_id, key, value) => ({
    type: CHANGE_BIKE_MODEL_VARIANTS_REQUEST, variant_id, key, value, prefix,
});

export const changeBikeModelVariantRequestSuccess = (key, variant) => ({
    type: CHANGE_BIKE_MODEL_VARIANTS_REQUEST_SUCCESS, key, variant, prefix,
});

export const changeBikeModelVariantRequestFailure = error => ({
    type: CHANGE_BIKE_MODEL_VARIANTS_REQUEST_FAILURE, error, prefix,
});



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Bike_model_update/redux/actions/change_bike_model_variants.actions.js